import { writable } from "svelte/store";
// store like
/**
 * {
 *  "lat,lng": {
 *    "stored": 12343425412,
 *    "json": {oprseresponse}
 *  }
 * }
 */
export const MemoisedDirections = writable({});
